import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

const ExportLocationsHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <h3>Export &amp; Transfer Locations</h3>
      <p>
        Manage the destinations users can pick when exporting or transferring
        clips. Locations are synced from Iconik.
      </p>
    </Box>
    <Box>
      <h3>How it works</h3>
      <ul>
        <li>Newly synced locations are disabled by default.</li>
        <li>
          Enable a location to make it selectable to users in the export and
          transfer flows.
        </li>
        <li>
          Disable a location to remove it as an option without deleting it.
        </li>
      </ul>
    </Box>
    <Box>
      <h3>Notes</h3>
      <ul>
        <li>Export locations and transfer destinations are managed here together.</li>
        <li>Re-syncing pulls the latest destinations from Iconik.</li>
      </ul>
    </Box>
  </SpaceBetween>
);

export default ExportLocationsHelpPanel;
